// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAw1ciIZd3mJQ20d-nrsSeYmCADER3K9gk",
  authDomain: "portfolio-4a7fd.firebaseapp.com",
  projectId: "portfolio-4a7fd",
  storageBucket: "portfolio-4a7fd.appspot.com",
  messagingSenderId: "1000626461689",
  appId: "1:1000626461689:web:f19c5b751d23932975bb28",
  measurementId: "G-VWY454VNQX"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db, collection, addDoc };